import { IonCol, IonBadge, IonIcon } from "@ionic/react";
import classNames from "classnames/bind";
import { closeOutline, heartOutline, heart } from "ionicons/icons";

import styles from "./NewListViewProduct.module.scss";

import React from "react";
import { Image } from "../../../../../components/Image/Image";
import { Product } from "@core/types";
import { useWishListData } from "../../../../../providers/wishListStore";
import { checkProductNew } from "../../../../../utils/checkProductNew";
import { calculateDiscount } from "../../../../../utils/calculateDiscount";
import { useConfig } from "../../../../../providers/config";
import { getPreviewImage } from "../../../../../utils/getPreviewImage";
import { useTranslation } from "react-i18next";

interface ImageWithBadgeAndWishlistProps {
  product: Product;
  lazyLoad?: boolean;
  type: "list-for-wish" | "newList";
}

const cx = classNames.bind(styles);

const ImageWithBadgeAndWishlist = ({ lazyLoad, product, type }: ImageWithBadgeAndWishlistProps) => {
  const config = useConfig();
  const productImage = getPreviewImage(product?.images[0]);
  const { toggleWish, isWishProduct } = useWishListData();
  const isProductNew = checkProductNew(product.dateCreated, config?.newProductDuration!);
  const { t } = useTranslation();
  const discount = calculateDiscount(
    product.type,
    product.onSale,
    product.price,
    product.regularPrice,
    product.priceHtml,
  );

  return (
    <IonCol sizeXs="4" sizeSm={"12"} className={cx("product-image", "productSpecial__imageWrapper")}>
      <div className={cx("badges")}>
        {isProductNew && (
          <IonBadge color="danger" className={cx("new", "badge")}>
            {t("NEW")}
          </IonBadge>
        )}
      </div>

      {!!discount && <IonBadge className={cx("new-product-label")}>{discount?.toFixed(0)}%</IonBadge>}

      <Image
        lazyLoad={lazyLoad}
        draggable={false}
        id="image"
        image={productImage}
        style={{ maxWidth: "100%", height: "150px" }}
      />

      <div className={cx("productsSpecialLeft__heart", "ion-hide-sm-down")}>
        {type === "list-for-wish" ? (
          <div
            onClick={(e) => {
              toggleWish(product.id);
              e.stopPropagation();
            }}
            className={cx("wishProduct__removeButton")}
          >
            <IonIcon icon={closeOutline} className={"wishList__removeIcon"} />
          </div>
        ) : !isWishProduct(product.id) ? (
          <div
            onClick={(e) => {
              toggleWish(product.id);
              e.stopPropagation();
            }}
          >
            <IonIcon color="secondary" className={cx("productHeartIcon")} icon={heartOutline} />
          </div>
        ) : (
          <div
            onClick={(e) => {
              toggleWish(product.id);
              e.stopPropagation();
            }}
          >
            <IonIcon className={cx("productHeartIcon")} color="secondary" icon={heart} />
          </div>
        )}
      </div>
    </IonCol>
  );
};

export default ImageWithBadgeAndWishlist;
